import { createContext, useCallback, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

const SetThemeContext = createContext(null);
export const useSetTheme = () => useContext(SetThemeContext);

export const ThemeProvider = ({ children }) => {
  const [theme, _setTheme] = useState(() => {
    try {
      return localStorage.getItem('theme-mode') || 'light';
    } catch {
      return 'light';
    }
  });

  const setTheme = useCallback((input) => {
    const newTheme = input ? 'dark' : 'light';
    _setTheme(newTheme);

    const html = document.documentElement;
    if (newTheme === 'light') {
      html.classList.remove('dark');
      localStorage.setItem('theme-mode', 'light');
    } else {
      html.classList.add('dark');
      localStorage.setItem('theme-mode', 'dark');
    }
  }, []);

  useEffect(() => {
    const html = document.documentElement;
    if (theme === 'dark') {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
  }, [theme]);

  return (
    <SetThemeContext.Provider value={setTheme}>
      <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
    </SetThemeContext.Provider>
  );
};
